import { render, staticRenderFns } from "./UserCorrectionDocumentCard.vue?vue&type=template&id=0113d88d&"
import script from "./UserCorrectionDocumentCard.vue?vue&type=script&lang=js&"
export * from "./UserCorrectionDocumentCard.vue?vue&type=script&lang=js&"
import style0 from "./UserCorrectionDocumentCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports